var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"data-src":_vm.videoData.src,"loop":_vm.loop,"autoplay":_vm.autoplay,"playsinline":"","data-poster":_vm.videoData.posterimage},domProps:{"muted":_vm.muted}},[_c('source',{attrs:{"src":"data:video/mp4;base64,AAAA","type":_vm.videoData.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }